            (function() {
        var STORAGE_PRODUCTS = 'meama_recent_products';
        var STORAGE_COLLECTION = 'meama_last_collection';
        var MAX_ITEMS = 20;

        var pageContext = {
          productHandle: "",
          collectionHandle: ""
        };

        function extractHandleFromUrl(url) {
          try {
            var parsed = new URL(url, window.location.origin);
            var parts = parsed.pathname.split('/').filter(Boolean);
            var idx = parts.indexOf('products');
            if (idx > -1) {
              var tail = parts.slice(idx + 1);
              if (tail.length) return tail[tail.length - 1];
            }
            return parts[parts.length - 1] || '';
          } catch (e) {
            return '';
          }
        }

        function getList() {
          try {
            var raw = localStorage.getItem(STORAGE_PRODUCTS);
            return raw ? JSON.parse(raw) : [];
          } catch (e) {
            return [];
          }
        }

        function persist(handle, collection) {
          if (!handle) return;
          try {
            var list = getList().filter(function(item) { return item && item !== handle; });
            list.unshift(handle);
            localStorage.setItem(STORAGE_PRODUCTS, JSON.stringify(list.slice(0, MAX_ITEMS)));
            if (collection) localStorage.setItem(STORAGE_COLLECTION, collection);
          } catch (e) {
            console.warn('[meama] storage unavailable', e);
          }
        }

        function persistFromPath() {
          var handle = '';
          var collection = '';
          try {
            var parts = window.location.pathname.split('/').filter(Boolean);
            var idx = parts.indexOf('products');
            if (idx > -1) {
              var tail = parts.slice(idx + 1);
              if (tail.length) handle = tail[tail.length - 1];
              if (idx >= 1 && parts[idx - 1] !== 'products') {
                collection = parts[idx - 1];
              }
              if (idx >= 2 && parts[idx - 2] === 'collections') {
                collection = parts[idx - 1];
              }
            }
          } catch (e) {
            handle = '';
          }

          if (handle) {
            persist(handle, collection);
          } else if (collection) {
            try { localStorage.setItem(STORAGE_COLLECTION, collection); } catch (e) {}
          }
        }

        if (pageContext.productHandle) {
          persist(pageContext.productHandle, pageContext.collectionHandle);
        } else if (pageContext.collectionHandle) {
          try { localStorage.setItem(STORAGE_COLLECTION, pageContext.collectionHandle); } catch(e) {}
        } else {
          persistFromPath();
        }

        window.addEventListener('pageshow', persistFromPath);

        document.addEventListener('click', function(event) {
          var link = event.target.closest('[data-product-handle], a[href*="/products/"]');

          if (!link) {
            var card = event.target.closest('.product-card');
            if (card) link = card.querySelector('[data-product-handle], a[href*="/products/"]');
          }

          if (!link) return;

          var handle = link.dataset.productHandle || extractHandleFromUrl(link.href);
          if (!handle) {
            var cardHandle = link.closest('.product-card');
            if (cardHandle) {
              handle = cardHandle.getAttribute('data-product-handle') || '';
              if (!handle) {
                var cardLink = cardHandle.querySelector('a[href*="/products/"]');
                if (cardLink) handle = extractHandleFromUrl(cardLink.href);
              }
            }
          }

          var collection = '';
          var collectionEl = link.closest('[data-collection-handle]') || event.target.closest('[data-collection-handle]');
          if (collectionEl && collectionEl.dataset.collectionHandle) {
            collection = collectionEl.dataset.collectionHandle;
          }

          persist(handle, collection);
        }, { passive: true });
      })();